const transactions = [
    { id: 1, description: 'Payment from Justin', date: '01 August', amount: '+$78.20' },
    { id: 2, description: 'Payment to Grocery Store', date: '27 July', amount: '-$29.50' },
    { id: 3, description: 'Salary Credit', date: '31 July', amount: '+$3942.64' },
    { id: 4, description: 'Payment from Lisa', date: '22 July', amount: '+$54.30' },
    { id: 5, description: 'Freelance Payment', date: '27 July', amount: '+$123.45' },
    { id: 6, description: 'Payment to James', date: '02 August', amount: '-$20.00' },
    { id: 7, description: 'Payment from Karen', date: '17 May', amount: '+$150.00' },
    { id: 8, description: 'Job Payment', date: '15 June', amount: '+$500.00' },
    { id: 9, description: 'Payment to Alex', date: '07 January', amount: '-$80.00' },
    { id: 10, description: 'Account Credit', date: '18 February', amount: '+$200.00' },
    { id: 11, description: 'Payment to Alex', date: '30 Apr', amount: '-$15.00' },
    { id: 12, description: 'Payment from John', date: '28 Apr', amount: '+$78.20' },
    { id: 13, description: 'Payment to Cafe', date: '27 Apr', amount: '-$12.50' },
    { id: 14, description: 'Online Purchase', date: '26 Apr', amount: '-$29.99' },
    { id: 15, description: 'Payment from Mike', date: '25 Apr', amount: '+$42.64' },
    { id: 16, description: 'Payment to Gym', date: '24 Apr', amount: '-$54.00' },
    { id: 17, description: 'Freelance Payment', date: '23 Apr', amount: '+$323.45' },
    { id: 18, description: 'Payment to Rent', date: '22 Apr', amount: '-$500.00' },
    { id: 19, description: 'Payment from Jane', date: '21 Apr', amount: '+$150.00' },
    { id: 20, description: 'Job Payment', date: '20 Apr', amount: '+$500.00' }
  ];

  export default transactions